<template>
  <div>
    <nav class="fixed-bottom">
      <div class="btn-group text-center" role="group" >
        <router-link v-if="canPrev" :to="prevStep" class="btn btn-secondary" tag="button">
            <font-awesome-icon icon="arrow-left" /> {{ $t("navigation.back") }}
        </router-link>
        <button v-if="this.current=='/extras'" type="button" class="btn btn-default">{{ $t("navigation.extras") }} <strong>${{sumExtras}}</strong></button>
        <button v-if="this.current=='/summary'" v-on:click="onSubmit()" type="button" class="btn btn-primary"><strong>{{ $t("navigation.reservation") }}</strong></button>
        <button type="button" v-if="canNext && !onlyBack" v-on:click="nextStep()" class="btn btn-primary"  :class="{'disabled':!validateNext}">
          {{ $t("navigation.continue") }} <font-awesome-icon icon="arrow-right" />
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'Navigation',
  props: {
    onlyBack: Boolean,
    prevRun: Function,
    onSubmit: Function
  },
  mounted() {
    if (!process.env.VUE_APP_BT_MODE_TEST) {
      this.onReloadRedirectoTo();
    }
  },
  data: () => {
    return {
      router: [
        '/',
        '/services',
        '/extras',
        '/information',
        '/summary'
      ],
    };
  },
  methods: {
    nextStep() {
      if (!this.validateNext) {
        this.$alertify.alert("Error", this.alertMsgFor());
        return ;
      }
      let next = this.router.indexOf(this.current);
      let nextPath = this.router[++next];
      if (nextPath === '/extras' && this.hasSetting && !this.settings.hasExtras) {
        nextPath = this.router[++next];
      }
      if (this.prevRun) {
        return this.prevRun().then(() => {
          this.$router.push(nextPath);
        }).catch((e) => {
          console.log(e);
        });
      } else {
        this.$router.push(nextPath);
      }
    },
    alertMsgFor() {
      if (this.current === "/") {
        return "Search invalid", "Select an element from the list or a point on the map";
      } else if(this.current === "/services") {
         return "Select a service";
      } else {
        return "Check fields"
      }
    },
    onReloadRedirectoTo(){
      let index = this.router.indexOf(this.current);
      const equals = this.fromPlace.placeId === this.toPlace.placeId;

      if (index > 0 && equals) {
        return this.$router.replace("/");
      }

      if (index  === 1 && this.form.serviceTypeID === null) {
        return this.$router.replace("/services");
      }

    }
  },
  computed:{
    ...mapState(['fromPlace', 'toPlace', 'form', 'settings', 'hasSetting']),
    ...mapGetters(['sumExtras']),
    current() {
      return this.$route.path;
    },
    canNext() {
      const prev = this.router.indexOf(this.current);
      if (this.current === this.router[this.router.length] || prev >= this.router.length-1) {
        return false;
      }

      return true;
    },
    canPrev() {
      const prev = this.router.indexOf(this.current);
      if (this.current === this.router[0] || prev <= 0) {
        return false;
      }
      return true;
    },
    prevStep() {
      let prev = this.router.indexOf(this.current);
      let prevPath = this.router[--prev];
      if (prevPath === '/extras' && this.hasSetting && !this.settings.hasExtras) {
        prevPath = this.router[--prev];
      }
      return prevPath;
    },
    validateNext() {
      if (this.current == '/') {
        const notNulls = this.fromPlace.placeId !== null &&
          this.toPlace.placeId !== null;
        if (notNulls && this.fromPlace.placeId !== this.toPlace.placeId) {
          return true;
        }
        return false;
      }

      if (this.current == '/services') {
        if (this.form.serviceTypeID != null) {
          return true;
        }
        return false;
      }

      return true;
    }
  }
}
</script>

<style scoped>

nav .btn-group{
  width: 100%;
}

</style>
